import { Button, Reveal, Tabs, TabsList, TabsTrigger, Text, Tooltip } from '@datanomik/core-ui';
import { ArrowLeftLine } from '@datanomik/core-ui/icons';
import React from 'react';
import { t } from 'i18next';
import { useLocation } from 'react-router';
import { useNavigateSearch } from '@/hooks/useNavigate';
import { GOVERNANCE_BASE_PATH } from '../shared/policies.constants';
import { SETTINGS_SECTIONS } from './settingsSections';

interface GovernanceSettingsPageProps {
  children: React.ReactNode;
}

export const GovernanceSettingsPage: React.FC<GovernanceSettingsPageProps> = ({ children }) => {
  const { pathname } = useLocation();
  const navigateSearch = useNavigateSearch();
  const activeSection = SETTINGS_SECTIONS.find(({ path }) => pathname.includes(path)) ?? SETTINGS_SECTIONS[0];

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center gap-3">
        <Tooltip label={t('policies.tab.home')}>
          <Button
            size="icon"
            variant="ghost"
            aria-label={t('policies.tab.home')}
            onClick={() => navigateSearch(GOVERNANCE_BASE_PATH)}
          >
            <ArrowLeftLine />
          </Button>
        </Tooltip>
        <Text variant="heading">{t('policies.settings.title')}</Text>
      </div>
      <Tabs value={activeSection.path} variant="pill" onValueChange={(path) => navigateSearch(path)}>
        <TabsList>
          {SETTINGS_SECTIONS.map(({ path, labelKey }) => (
            <TabsTrigger key={path} value={path}>{t(labelKey)}</TabsTrigger>
          ))}
        </TabsList>
      </Tabs>
      <Reveal key={activeSection.path} preset="fade">
        <React.Suspense fallback={null}>{children}</React.Suspense>
      </Reveal>
    </div>
  );
};
